<template>
	<v-dialog
		v-model='dialog'
		:width='width'
	>
		<v-card v-if='!isSubmitted'>
			<v-card-title>
				<span>Suchauftrag verwalten</span>
				<v-spacer />
				<v-icon class='ml-2' size='12' @click='handleDialog'>
					far fa-times
				</v-icon>
			</v-card-title>
			<v-card-text>
				<p><strong>Deine Suchaufträge</strong></p>
				<p>Welchen Suchauftrag möchtest du löschen?</p>

				<div class='mb-5'>
					<v-checkbox
						v-for='(entry, index) in entries'
						:key='index'
						v-model='entry.isChecked'
						color='red'
						hide-details
						:label='entry.formatted_text'
						@change='handleCheckbox(entry)'
					/>
				</div>
				<div class='mt-5'>
					<v-btn
						class='submit-button mb-3'
						text
						block
						@click='submit'
					>
						Löschen
					</v-btn>
					<v-btn
						class='abort-button'
						text
						block
						@click='handleDialog'
					>
						Abbrechen
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
		<v-card v-if='isSubmitted'>
			<v-card-title>
				<span>Suchauftrag verwalten</span>
				<v-spacer />
				<v-icon class='ml-2' size='12' @click='handleDialog'>
					far fa-times
				</v-icon>
			</v-card-title>
			<v-card-text>
				<p class='text-center py-5 my'>
					Die ausgewählten Suchaufträge wurden erfolgreich gelöscht
				</p>
			</v-card-text>
			<v-card-actions>
				<v-btn
					class='abort-button'
					text
					block
					@click='handleDialog'
				>
					Schliessen
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'SearchOrderManagerDialog',
    components: {},
    props: {
      searchOrderId: {
        default: '',
        type: String
      }
    },
    data() {
      return {
        dialog: false,
        checkedEntries: [],
        isSubmitted: false,
        faarenApiURL: process.env.FAAREN_API_URL,
        entries: [],
        filter: [
            'current_mileage',
            'fuel'
        ]
      }
    },
    computed: {
      width(){
        if(this.$vuetify.breakpoint.mobile){
          return 'auto';
        }
        return 740;
      }
    },
    watch: {
      searchOrderId: function (val) {
        this.initDialog()
      }
    },
    beforeDestroy () {
      if (typeof window === 'undefined') return
      window.removeEventListener('resize', this.onResize, { passive: true })
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      this.initDialog()
    },
    methods: {
      initDialog(){
        if(this.searchOrderId !== ''){
          this.getEntries()
        }
      },
      handleDialog(){
        this.dialog = !this.dialog
      },
      onResize() {
        this.isMobile = window.innerWidth < 600
      },
      async getEntries(){
        axios
          .get(`${process.env.VUE_APP_API_URL}/v1.0/de-de/search-order/${this.searchOrderId}`).then(r => {
            this.entries = r.data
            this.dialog = true
          }).catch(e => {
            console.log('get search order error', e)
          })
      },
      handleCheckbox(entry) {
        const index = this.checkedEntries.findIndex(item => item.uuid === entry.uuid )
        if(index === -1){
          this.checkedEntries.push(entry)
        } else {
          this.checkedEntries.splice(index, 1)
        }
      },
      submit() {
        const self = this
        this.checkedEntries.map(function(entry, key) {
            axios
              .delete(`${process.env.VUE_APP_API_URL}/v1.0/de-de/search-order/${self.searchOrderId}/${entry.uuid}`)
              .catch(e => {
               console.log('delete search order error', e)
              })
        });
        this.isSubmitted = true
      }
    }
  }
</script>

<style scoped lang='scss'>
.submit-button {
  border-radius: 3px;
  border: solid 1px red;
  background-color: red;
  color: #fff
}
.abort-button {
  background: #343A40;
  color: #fff;
}

.v-card__title {
  border-bottom: 1px solid #d0d0d0;
}
</style>